import { render, staticRenderFns } from "./WorkdepartmentbudgetChange.vue?vue&type=template&id=095f47f6&scoped=true&"
import script from "./WorkdepartmentbudgetChange.vue?vue&type=script&lang=js&"
export * from "./WorkdepartmentbudgetChange.vue?vue&type=script&lang=js&"
import style0 from "./WorkdepartmentbudgetChange.vue?vue&type=style&index=0&id=095f47f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f47f6",
  null
  
)

export default component.exports